export default __webpack_public_path__ + "static/media/file-search.2694bf95.png";